import styled from 'styled-components';
import colors from '../../theme/colors';

import { styled as muiStyled } from '@material-ui/core/styles';
import MuiTypography from '@material-ui/core/Typography';
import MuiFormControl from '@material-ui/core/FormControl';

export const Heading = styled.h1`
  font-size: 3rem;
  line-height: 3rem;
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.text};
  font-family: 'Urbanist';
`;

export const HeadingXL = styled(Heading)`
  font-size: 4rem;
  line-height: 4rem;
  margin: 0 0 2rem 0;
`;

export const Heading2 = styled(Heading)`
  font-size: 2.5rem;
  line-height: 2.5rem;
`;
export const Heading3 = styled(Heading)`
  font-size: 2rem;
  line-height: 2rem;
`;

export const Text = styled.p`
  margin: 0;
  line-height: 1rem;
  font-size: 1rem;
  color: ${({ theme }) => theme.text};
  font-family: 'Urbanist';
`;

export const BoldText = styled(Text)`
  font-weight: 600;
`;

export const LargeText = styled(Text)`
  line-height: 1.5rem;
  font-size: 1.5rem;
`;

export const MedText = styled(Text)`
  font-size: 0.8rem;
`;

export const SmallText = styled(Text)`
  line-height: 0.6rem;
  font-size: 0.6rem;
`;

export const Label = styled('label')`
  line-height: 1rem;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-family: 'Urbanist';
  color: ${({ theme, error }) => (error ? colors.red : colors.lightBlack)};
`;

export const Spacer = styled.span`
  flex: 1 1 auto;
`;
export const Typography = styled(MuiTypography)`
  font-family: 'Urbanist';
`;
export const FormControl = muiStyled(MuiFormControl)(() => ({
  fontFamily: 'Urbanist',
  '&.MuiFormControl-root': {
    minWidth: 106,
    maxWidth: 106,
  },
  '& .MuiInputBase-root': {
    fontFamily: 'Urbanist',
    height: 35,
    color: colors.blackShades[2],
    '& .MuiSelect-selectMenu': {
      fontSize: 12,
      color: colors.blackShades[2],
      fontWeight: 600,
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiFormLabel-root': {
    fontFamily: 'Urbanist',
    fontSize: 12,
    color: colors.blackShades[2],
    fontWeight: 600,
    '&.MuiInputLabel-outlined': {
      transform: 'translate(10px, 12px) scale(1)',
    },
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.9)',
    },
  },
}));
